import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Layout,
  List,
  Card,
  Typography,
  Tag,
  Table,
  Image,
  Button,
  Collapse,
  Spin,
  Input,
  Select,
  Space,
  Empty,
  Divider,
  Pagination,
  Badge,
  Descriptions,
  message,
  Menu,
  Tabs,
} from 'antd';

const { Sider, Content } = Layout;
const { Title, Text, Paragraph } = Typography;
const { Search } = Input;

const CAFE_MENUS = [
  {
    key: 'ALL',
    label: '전체',
    menuId: null,
    menuCategory: '전체',
  },
  {
    key: '41',
    label: '업체후기(스튜디오)',
    menuId: 41,
    menuCategory: '업체후기_스튜디오',
  },
  {
    key: '135',
    label: '업체후기(웨딩통합)',
    menuId: 135,
    menuCategory: '업체후기_웨딩통합',
  },
  {
    key: '136',
    label: '업체후기(혼수)',
    menuId: 136,
    menuCategory: '업체후기_혼수',
  },
  {
    key: '350',
    label: '예식완료 후 총평가',
    menuId: 350,
    menuCategory: '예식완료_총평가',
  },
  {
    key: '170',
    label: '내 웨딩사진 자랑하기',
    menuId: 170,
    menuCategory: '웨딩사진',
  },
];
function getStatusColor(status) {
  if (status === 'DONE') return 'green';
  if (status === 'PROCESSING') return 'blue';
  if (status === 'FAILED') return 'red';
  return 'default';
}

function percent(value) {
  if (value == null || value === '') return '-';

  const num = Number(value);

  if (Number.isNaN(num)) return '-';

  return `${Math.round(num * 100)}%`;
}

export default function CafeArticleReviewAdminPage() {
  const [selectedMenuKey, setSelectedMenuKey] = useState('ALL');
  const [keyword, setKeyword] = useState('');
  const [analysisStatus, setAnalysisStatus] = useState('');

  const [page, setPage] = useState(1);
  const [rows] = useState(20);

  const [articleList, setArticleList] = useState([]);
  const [total, setTotal] = useState(0);

  const [selectedArticleId, setSelectedArticleId] = useState(null);
  const [detail, setDetail] = useState(null);

  const [listLoading, setListLoading] = useState(false);
  const [detailLoading, setDetailLoading] = useState(false);

  const selectedMenu = CAFE_MENUS.find((item) => item.key === selectedMenuKey);

  const fetchArticleList = async (nextPage = page) => {
    try {
      setListLoading(true);

      const response = await axios.get('/api/admin/cafe-articles', {
        params: {
          menuId: selectedMenu?.menuId || undefined,
          keyword: keyword || undefined,
          analysisStatus: analysisStatus || undefined,
          page: nextPage,
          rows,
        },
      });

      const result = response.data?.data || {};

      setArticleList(result.items || []);
      setTotal(Number(result.total || 0));
      setPage(Number(result.page || nextPage));

      if (!selectedArticleId && result.items?.[0]?.id) {
        setSelectedArticleId(result.items[0].id);
      }
    } catch (error) {
      console.error(error);
      message.error(
        error.response?.data?.message ||
          '게시글 목록을 불러오는 중 오류가 발생했습니다.',
      );
    } finally {
      setListLoading(false);
    }
  };

  const fetchArticleDetail = async (articleId) => {
    if (!articleId) {
      setDetail(null);
      return;
    }

    try {
      setDetailLoading(true);

      const response = await axios.get(`/api/admin/cafe-articles/${articleId}`);

      setDetail(response.data?.data || null);
    } catch (error) {
      console.error(error);
      message.error(
        error.response?.data?.message ||
          '게시글 상세를 불러오는 중 오류가 발생했습니다.',
      );
    } finally {
      setDetailLoading(false);
    }
  };

  useEffect(() => {
    fetchArticleList(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMenuKey, analysisStatus]);

  useEffect(() => {
    fetchArticleDetail(selectedArticleId);
  }, [selectedArticleId]);

  const article = detail?.article;
  const analysis = detail?.analysis;
  const analyzedShops = detail?.analyzedShops || [];
  const images = detail?.images || [];
  const comments = detail?.comments || [];

  return (
    <Layout style={{ height: '100vh', background: '#f5f5f5' }}>
      <Sider
        width={220}
        theme="light"
        style={{
          borderRight: '1px solid #eee',
          overflow: 'auto',
        }}
      >
        <div style={{ padding: 16 }}>
          <Title level={5} style={{ margin: 0 }}>
            게시판
          </Title>
          <Text type="secondary" style={{ fontSize: 12 }}>
            카페 게시판별 분석 결과
          </Text>
        </div>

        <Menu
          mode="inline"
          selectedKeys={[selectedMenuKey]}
          onClick={(item) => {
            setSelectedMenuKey(item.key);
            setSelectedArticleId(null);
            setDetail(null);
            setPage(1);
          }}
          items={CAFE_MENUS.map((menu) => ({
            key: menu.key,
            label: menu.label,
          }))}
        />
      </Sider>

      <div
        width={430}
        theme="light"
        style={{
          borderRight: '1px solid #eee',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          width: 430,
        }}
        
      >
        <div style={{ padding: 16, borderBottom: '1px solid #eee' }}>
          <Space direction="vertical" style={{ width: '100%' }} size={10}>
            <Title level={5} style={{ margin: 0 }}>
              글 리스트
            </Title>

            <Search
              allowClear
              placeholder="제목 검색"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              onSearch={() => {
                setPage(1);
                fetchArticleList(1);
              }}
            />
            <Tabs
              size="small"
              activeKey={analysisStatus || 'ALL'}
              onChange={(key) => {
                setAnalysisStatus(key === 'ALL' ? '' : key);
                setSelectedArticleId(null);
                setDetail(null);
                setPage(1);
              }}
              items={[
                {
                  key: 'ALL',
                  label: '전체',
                },
                {
                  key: 'DONE',
                  label: '완료',
                },
                {
                  key: 'PROCESSING',
                  label: '진행중',
                },
                {
                  key: 'FAILED',
                  label: '실패',
                },
                {
                  key: 'PENDING',
                  label: '대기',
                },
              ]}
            />
            {/* <Select
              allowClear
              value={analysisStatus || undefined}
              placeholder="분석 상태"
              style={{ width: '100%' }}
              onChange={(value) => {
                setAnalysisStatus(value || '');
                setSelectedArticleId(null);
                setDetail(null);
                setPage(1);
              }}
              options={[
                {
                  value: 'DONE',
                  label: '분석 완료',
                },
                {
                  value: 'PROCESSING',
                  label: '분석중',
                },
                {
                  value: 'FAILED',
                  label: '분석 실패',
                },
                {
                  value: 'PENDING',
                  label: '대기',
                },
              ]}
            /> */}
          </Space>
        </div>

        <div style={{ flex: 1, minHeight: 0,  padding: 12 }}>
          <div style={{height: '100%', overflow: 'auto',}}>
            <Spin spinning={listLoading}>
              <List
                dataSource={articleList}
                locale={{
                  emptyText: <Empty description="게시글이 없습니다." />,
                }}
                renderItem={(item) => {
                  const selected = selectedArticleId === item.id;

                  const imageCount = Number(item.imageCount || 0);
                  const matchedImageCount = Number(item.matchedImageCount || 0);

                  const matchedPercent =
                    imageCount > 0
                      ? Math.round((matchedImageCount / imageCount) * 100)
                      : 0;

                  const statusColor =
                    item.analysisStatus === 'DONE'
                      ? '#52c41a'
                      : item.analysisStatus === 'PROCESSING'
                        ? '#1677ff'
                        : item.analysisStatus === 'FAILED'
                          ? '#ff4d4f'
                          : '#999';

                  return (
                    <List.Item style={{ padding: 0, marginBottom: 10 }}>
                      <Card
                        size="small"
                        hoverable
                        onClick={() => setSelectedArticleId(item.id)}
                        style={{
                          width: '100%',
                          borderColor: selected ? '#1677ff' : statusColor,
                          borderLeft: `4px solid ${statusColor}`,
                          background: selected ? '#f0f7ff' : '#fff',
                          cursor: 'pointer',
                        }}
                        bodyStyle={{ padding: 12 }}
                      >
                        <Space
                          direction="vertical"
                          size={8}
                          style={{ width: '100%' }}
                        >
                          <Text
                            strong
                            ellipsis
                            style={{
                              width: '100%',
                              fontSize: 14,
                            }}
                          >
                            {item.title}
                          </Text>

                          

                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              gap: 12,
                              alignItems: 'flex-start',
                            }}
                          >
                            <Text
                              style={{
                                fontSize: 12,
                                minWidth: 0,
                                flex: 1,
                              }}
                              ellipsis
                            >
                              대표 업체{' '}
                              <Text strong>
                                {item.primaryShopName || '-'}
                              </Text>
                            </Text>

                            <Tag
                              color={getStatusColor(item.analysisStatus)}
                              style={{ marginRight: 0 }}
                            >
                              {item.analysisStatus || '상태없음'}
                            </Tag>
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              gap: 12,
                              alignItems: 'flex-start',
                            }}
                          >
                            <Text type="" style={{ fontSize: 12 }}>
                              업체 {item.relatedShopCount || 0} | 사진 {imageCount} | 매칭{' '}
                              {matchedImageCount} ({matchedPercent}%)
                            </Text>
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              gap: 12,
                              alignItems: 'flex-start',
                            }}
                          >
                            <Text style={{ fontSize: 12 }}>
                              {item.menuName || '-'} | 조회 {item.readCount || 0} | 댓글{' '}
                              {item.commentCount || 0}
                            </Text>

                            <Text type="secondary" style={{ fontSize: 12 }}>
                              {item.writeDate
                                ? String(item.writeDate).slice(0, 10)
                                : '-'}
                            </Text>
                          </div>
                        </Space>
                      </Card>
                    </List.Item>
                  );
                }}
              />
            </Spin>
          </div>
        </div>

        <div
          style={{
            padding: 12,
            borderTop: '1px solid #eee',
            background: '#fff',
          }}
        >
          <Pagination
            size="small"
            current={page}
            pageSize={rows}
            total={total}
            showSizeChanger={false}
            onChange={(nextPage) => {
              setPage(nextPage);
              fetchArticleList(nextPage);
            }}
          />
        </div>
      </div>

      <Content style={{ overflow: 'auto', padding: 20, paddingLeft: 0 }}>
        <Spin spinning={detailLoading}>
          {!article ? (
            <Empty description="글을 선택해주세요." />
          ) : (
            <Space direction="vertical" size={16} style={{ width: '100%' }}>
              <Card>
                <Space direction="vertical" size={8} style={{ width: '100%' }}>
                  <Space align="start" style={{ justifyContent: 'space-between', width: '100%' }}>
                    <div>
                      <Title level={4} style={{ marginTop: 0, marginBottom: 6 }}>
                        {article.title}
                      </Title>

                      <Space size={6} wrap>
                        <Tag>{article.menuName || '-'}</Tag>
                        <Tag color={getStatusColor(article.analysisStatus)}>
                          {article.analysisStatus || '상태없음'}
                        </Tag>
                        <Text type="secondary">
                          {article.writeDate
                            ? String(article.writeDate).slice(0, 10)
                            : '-'}
                        </Text>
                        <Text type="secondary">조회 {article.readCount || 0}</Text>
                        <Text type="secondary">댓글 {article.commentCount || 0}</Text>
                        <Text type="secondary">사진 {images.length}</Text>
                      </Space>
                    </div>

                    {article.articleUrl && (
                      <Button
                        onClick={() => window.open(article.articleUrl, '_blank')}
                      >
                        원문 열기
                      </Button>
                    )}
                  </Space>

                  {article.analysisErrorMsg && (
                    <Text type="danger">{article.analysisErrorMsg}</Text>
                  )}
                </Space>
              </Card>

              <Card title="AI 요약">
                {analysis ? (
                  <Space direction="vertical" size={12} style={{ width: '100%' }}>
                    <Descriptions size="small" column={4} bordered>
                      <Descriptions.Item label="대표 업체">
                        {analysis.primaryShopName || '-'}
                      </Descriptions.Item>
                      <Descriptions.Item label="후기 유형">
                        {analysis.reviewType || '-'}
                      </Descriptions.Item>
                      <Descriptions.Item label="감성">
                        {analysis.sentiment || '-'}
                      </Descriptions.Item>
                      <Descriptions.Item label="불만 강도">
                        {analysis.complaintLevel || '-'}
                      </Descriptions.Item>
                    </Descriptions>

                    <div>
                      <Text strong>요약</Text>
                      <Paragraph style={{ marginTop: 6, marginBottom: 0 }}>
                        {analysis.summary || '-'}
                      </Paragraph>
                    </div>

                    {analysis.customerEvaluation && (
                      <div>
                        <Text strong>고객 평가</Text>
                        <Paragraph style={{ marginTop: 6, marginBottom: 0 }}>
                          {analysis.customerEvaluation}
                        </Paragraph>
                      </div>
                    )}
                    <div style={{display: 'flex', gap: 24}}>
                      <div style={{flex: 1}}>
                        <Text strong>장점</Text>
                        <div style={{ marginTop: 6 }}>
                          {(analysis.strengths || []).length === 0 ? (
                            <div>
                              <Text type="secondary">-</Text>
                            </div>
                          ) : (
                            analysis.strengths.map((item, index) => (
                              <div key={index} >
                                <Tag color="green" style={{ marginBottom: 6 }}>
                                  {item}
                                </Tag>
                              </div>
                            ))
                          )}
                        </div>
                      </div>

                      <div style={{flex: 1}}>
                        <Text strong>단점/주의점</Text>
                        <div style={{ marginTop: 6 }}>
                          {(analysis.weaknesses || []).length === 0 ? (
                            <Text type="secondary">-</Text>
                          ) : (
                            analysis.weaknesses.map((item, index) => (
                              <Tag key={index} color="orange" style={{ marginBottom: 6 }}>
                                {item}
                              </Tag>
                            ))
                          )}
                        </div>
                      </div>
                    </div>
                    <Collapse
                      size="small"
                      items={[
                        {
                          key: 'content',
                          label: '전체 본문 보기',
                          children: (
                            <Paragraph
                              style={{
                                whiteSpace: 'pre-wrap',
                                maxHeight: 420,
                                overflow: 'auto',
                                background: '#fafafa',
                                padding: 12,
                                borderRadius: 8,
                              }}
                            >
                              {article.contentText || '-'}
                            </Paragraph>
                          ),
                        },
                        {
                          key: 'comments',
                          label: `댓글 보기 (${comments.length})`,
                          children: comments.length ? (
                            <List
                              size="small"
                              dataSource={comments}
                              renderItem={(comment) => (
                                <List.Item>
                                  <Space direction="vertical" size={2}>
                                    <Space>
                                      <Text strong>
                                        {comment.writerNickname || '-'}
                                      </Text>
                                      {Number(comment.isArticleWriter) === 1 && (
                                        <Tag color="blue">작성자</Tag>
                                      )}
                                      {Number(comment.isReply) === 1 && (
                                        <Tag>답글</Tag>
                                      )}
                                    </Space>
                                    <Text>{comment.content}</Text>
                                  </Space>
                                </List.Item>
                              )}
                            />
                          ) : (
                            <Empty description="댓글이 없습니다." />
                          ),
                        },
                      ]}
                    />
                  </Space>
                ) : (
                  <Empty description="분석 결과가 없습니다." />
                )}
              </Card>

              <Card title="업체 분석">
                <Table
                  size="small"
                  rowKey="id"
                  dataSource={analyzedShops}
                  pagination={false}
                  columns={[
                    {
                      title: '업체명',
                      dataIndex: 'shopName',
                      width: 180,
                      render: (value, row) => (
                        <Space>
                          <Text strong>{value}</Text>
                          {Number(row.isPrimaryShop) === 1 && (
                            <Tag color="blue">대표</Tag>
                          )}
                        </Space>
                      ),
                    },
                    {
                      title: '분류',
                      dataIndex: 'shopCategory',
                      width: 100,
                    },
                    {
                      title: '역할',
                      dataIndex: 'roleInArticle',
                      width: 100,
                    },
                    {
                      title: '감성',
                      dataIndex: 'sentiment',
                      width: 100,
                    },
                    {
                      title: '신뢰도',
                      dataIndex: 'confidence',
                      width: 100,
                      render: percent,
                    },
                  ]}
                  expandable={{
                    expandedRowRender: (row) => (
                      <div
                        style={{
                          padding: '6px 12px',
                          background: '#fafafa',
                          borderRadius: 6,
                          color: '#555',
                          lineHeight: 1.6,
                        }}
                      >
                        <Text type="secondary" style={{ marginRight: 8 }}>
                          판단 근거
                        </Text>
                        <Text>{row.evidenceText || '-'}</Text>
                      </div>
                    ),
                    rowExpandable: (row) => !!row.evidenceText,
                    defaultExpandAllRows: true,
                    expandIcon: () => null,
                  }}
                />
              </Card>

              <Card
                title={
                  <Space>
                    <span>이미지 분석</span>
                    <Badge count={images.length} style={{ backgroundColor: '#1677ff' }} />
                  </Space>
                }
              >
                {images.length === 0 ? (
                  <Empty description="이미지가 없습니다." />
                ) : (
                  <Space direction="vertical" size={16} style={{ width: '100%' }}>
                    {images.map((image) => {
                      const allTags = [
                        ...(image.tags?.displayGroups || []).map((v) => ({
                          text: v,
                          color: 'blue',
                        })),
                        ...(image.tags?.serviceTags || []).map((v) => ({
                          text: v,
                          color: 'green',
                        })),
                        ...(image.tags?.contextTags || []).map((v) => ({
                          text: v,
                          color: 'purple',
                        })),
                        ...(image.tags?.visualTags || []).map((v) => ({
                          text: v,
                          color: 'default',
                        })),
                        ...(image.tags?.riskTags || []).map((v) => ({
                          text: v,
                          color: 'red',
                        })),
                      ];

                      return (
                        <Card
                          key={image.imageId}
                          size="small"
                          style={{ borderColor: '#eee' }}
                          title={
                            <Space>
                              <span>이미지 #{image.imageIndex}</span>
                              <Tag color={getStatusColor(image.imageAnalysisStatus)}>
                                {image.imageAnalysisStatus || '분석없음'}
                              </Tag>
                              {image.usableForApp === 1 && (
                                <Tag color="green">사용 가능</Tag>
                              )}
                              {image.usableForApp === 0 && (
                                <Tag color="orange">검수 필요</Tag>
                              )}
                            </Space>
                          }
                        >
                          <div
                            style={{
                              display: 'grid',
                              gridTemplateColumns: '260px 1fr',
                              gap: 16,
                            }}
                          >
                            <div>
                              {image.imageUrl ? (
                                <Image
                                  src={image.imageUrl}
                                  width="100%"
                                  style={{
                                    maxHeight: 360,
                                    objectFit: 'contain',
                                    background: '#f5f5f5',
                                    borderRadius: 8,
                                  }}
                                />
                              ) : (
                                <Empty description="이미지 URL 없음" />
                              )}
                            </div>

                            <Space
                              direction="vertical"
                              size={12}
                              style={{ width: '100%' }}
                            >
                              <Descriptions size="small" column={3} bordered>
                                <Descriptions.Item label="품질점수">
                                  {image.qualityScore || '-'}
                                </Descriptions.Item>
                                {/* <Descriptions.Item label="백업상태">
                                  {image.backupStatus || '-'}
                                </Descriptions.Item> */}
                                <Descriptions.Item label="분석상태">
                                  {image.imageAnalysisStatus || '-'}
                                </Descriptions.Item>
                              </Descriptions>

                              <div>
                                <Text strong>이미지 설명</Text>
                                <Paragraph style={{ marginTop: 6 }}>
                                  {image.imageSummary || '-'}
                                </Paragraph>
                              </div>

                              <div>
                                <Text strong>태그</Text>
                                <div style={{ marginTop: 6 }}>
                                  {allTags.length === 0 ? (
                                    <Text type="secondary">태그 없음</Text>
                                  ) : (
                                    allTags.map((tag, index) => (
                                      <Tag
                                        key={`${tag.text}-${index}`}
                                        color={tag.color}
                                        style={{ marginBottom: 6 }}
                                      >
                                        {tag.text}
                                      </Tag>
                                    ))
                                  )}
                                </div>
                              </div>

                              

                              {image.imageAnalysisErrorMsg && (
                                <Text type="danger">
                                  {image.imageAnalysisErrorMsg}
                                </Text>
                              )}

                              {image.backupErrorMsg && (
                                <Text type="danger">
                                  {image.backupErrorMsg}
                                </Text>
                              )}
                            </Space>
                          </div>
                          <div>
                            <Text strong>연결 업체</Text>

                            <Table
                              size="small"
                              rowKey={(row, index) =>
                                `${image.imageId}-${row.cafeExtractedShopId}-${index}`
                              }
                              dataSource={image.matchedShops || []}
                              pagination={false}
                              style={{ marginTop: 8 }}
                              columns={[
                                {
                                  title: '업체명',
                                  dataIndex: 'shopName',
                                  width: 180,
                                  render: (value, row) => (
                                    <Space>
                                      <Text strong>{value}</Text>
                                      {Number(row.isPrimaryForImage) === 1 && (
                                        <Tag color="blue">대표</Tag>
                                      )}
                                    </Space>
                                  ),
                                },
                                {
                                  title: '업체분류',
                                  dataIndex: 'shopCategory',
                                  width: 100,
                                },
                                {
                                  title: '이미지분류',
                                  dataIndex: 'shopImageCategory',
                                  width: 150,
                                  render: (value) => value || '미분류',
                                },
                                {
                                  title: '신뢰도',
                                  dataIndex: 'confidence',
                                  width: 90,
                                  render: percent,
                                },
                                {
                                  title: '매칭방식',
                                  dataIndex: 'matchType',
                                  width: 130,
                                },
                              ]}
                              expandable={{
                                expandedRowRender: (row) => (
                                  <div
                                    style={{
                                      padding: '6px 12px',
                                      background: '#fafafa',
                                      borderRadius: 6,
                                      color: '#555',
                                      lineHeight: 1.6,
                                    }}
                                  >
                                    <Text type="secondary" style={{ marginRight: 8 }}>
                                      매칭 이유
                                    </Text>
                                    <Text>{row.reason || '-'}</Text>
                                  </div>
                                ),
                                rowExpandable: (row) => !!row.reason,
                                defaultExpandAllRows: true,
                                // : true,
                                expandIcon: () => null,
                              }}
                              locale={{
                                emptyText: '연결된 업체 없음',
                              }}
                            />
                              </div>
                        </Card>
                      );
                    })}
                  </Space>
                )}
              </Card>
            </Space>
          )}
        </Spin>
      </Content>
    </Layout>
  );
}